import axios from "axios";
import CryptoJS from "crypto-js";
import { getLocalToken, getHost, getHeaders } from "./config";
import { getRefreshToken } from "../zservices/BasicAPIFunctions";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";
import { decryptAES256 } from "../../utils/crypto";
import { IS_TEST_V3 } from "../../assests/extention/commonfunction";

const laung = localStorage.getItem("laung") || "en";

const headers = {};
const axiosInstance = axios.create({
  baseURL: getHost(),
  withCredentials: true,
  headers,
});

// 🔹 Request interceptor
axiosInstance.interceptors.request.use(async (config) => {
  const token = getLocalToken();
  const defaultHeaders = getHeaders(config.url);

  // If data is FormData, remove Content-Type from defaults to let browser/axios handle it with boundary
  if (config.data instanceof FormData) {
    delete defaultHeaders["Content-Type"];
  }

  // Merge default headers with custom ones, custom headers take precedence
  config.headers = { ...defaultHeaders, ...config.headers };

  // Don't add Authorization header if it's the refresh token endpoint
  if (token && !config.url?.includes("auth/refresh-token")) {
    config.headers.Authorization = token;
  }
  return config;
});

// 🔹 Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    try {
      // Only decrypt if the data is an encrypted string.
      // If it's already an object, the backend has already decrypted it or it's a plain response.
      if (typeof response.data === "string") {
        // console.log("Encrypted Response:", JSON.stringify(response.data), "config.url", response?.config?.url);
        const decryptedString = decryptAES256(response.data);
        const decryptedData = JSON.parse(decryptedString);
        let reqPayload = response?.config?.data;
        if (typeof reqPayload == "string") {
          try { reqPayload = JSON.parse(reqPayload); } catch (e) { }
        }
        console.log("API RESPONSE:", decryptedData, "PAYLOAD", reqPayload, "API END POINT", response?.config?.url);
        return { data: decryptedData };
      }
      return { data: response.data };
    } catch (decryptError) {
      return Promise.reject(decryptError);
    }
  },
  async (error) => {
    // 🔹 Handle no internet / server down
    if (!error.response) {
      // You can replace alert with toast/snackbar for better UX
      // alert("No internet connection. Please check your network.");
      urtoast("No internet connection. Please check your network.", 2)
      return Promise.reject(error);
    }

    // 🔹 Handle 429 Too Many Requests
    if (error.response?.status == 429) {
      urtoast("Too many requests. Please try again later.", 2);
      return Promise.reject(error);
    }

    // 🔹 Handle unauthorized (401)
    if (error.response?.status == 401 && !error.config._retry) {
      error.config._retry = true;
      const refresh_token = localStorage.getItem("refresh_token");

      if (refresh_token) {
        try {
          // Use a clean call to getRefreshToken
          const res = await getRefreshToken({ refresh_token });

          if (res?.data?.status) {
            const newToken = res.data.response.token;
            localStorage.setItem("urexperttoken", newToken);

            if (res.data.response.refresh_token) {
              localStorage.setItem("refresh_token", res.data.response.refresh_token);
            }

            // Update Authorization header for the retry attempt
            error.config.headers.Authorization = newToken;

            // Retry the original request with the new token
            return axiosInstance(error.config);
          } else {
            // If refresh response is not success, logout
            console.error("Token refresh failed:", res?.data);
            localStorage.clear();
            window.location.href = `${process.env.PUBLIC_URL}/${laung}/loginwithemail`;
          }
        } catch (refreshErr) {
          // If refresh itself fails with 429, show error but don't logout
          if (refreshErr.response?.status == 429) {
            urtoast("Too many requests during token refresh. Please try again later.", 2);
            return Promise.reject(refreshErr);
          }

          // For any other refresh error (including 401 on refresh endpoint), logout
          console.error("Refreshing token error:", refreshErr);
          localStorage.clear();
          window.location.href = `${process.env.PUBLIC_URL}/${laung}/loginwithemail`;
        }
      } else {
        // No refresh token available, logout
        localStorage.clear();
        window.location.href = `${process.env.PUBLIC_URL}/${laung}/loginwithemail`;
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
